import { BsEyeFill, BsPlusCircle } from "react-icons/bs";
import { Modal, ModalBody, ModalOverlay } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import Checkbox from "components/checkbox";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { getProfileSecond } from "api/graphQL_users";
import InputField from "components/fields/InputField";
import { Link } from "react-router-dom";
import { createAPItoken, getAPIAccessTokenById, updateAPITokenRecord, verifyBackOfficeAPI } from "api/api_access";
import { MdEdit, MdHighlightOff, MdInfo } from "react-icons/md";
import DivLoader from "components/divloader/DivLoader";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

/* ── Permission sections config ── */
const PERM_SECTIONS = [
  { id: "client", label: "Client", color: "blue",
    data: ["Create client","Get all clients","Get client details","Update client details","Delete client"] },
  { id: "user", label: "User", color: "green",
    data: ["Register user","Verify otp","Get user profile","Get all users details","Create 2fa auth details","Update user profile","Update user password","Update user details","Manage 2fa authentication","Delete user profile","Delete user details"] },
  { id: "organization", label: "Organization", color: "blue",
    data: ["Create organization","Get all organization","Get organization details","Update organization details","Delete organization"] },
  { id: "transaction", label: "Transaction", color: "amber",
    data: ["Get all payments details","Get payment history","Refund payment","Retry payment","Change payment status","View Report"] },
  { id: "gateway", label: "Gateways", color: "purple",
    data: ["Get all gateways","Get gateway details"] },
  { id: "subscription", label: "Subscriptions", color: "blue",
    data: ["Get all subscription","Get subscription details","Cancel subscription"] },
  { id: "token", label: "Tokens", color: "amber",
    data: ["Get all token","Get token"] },
  { id: "role", label: "Roles", color: "red",
    data: ["Create role","Get role by id","Get all roles","Update role","Delete role"] },
  { id: "dashboard", label: "Dashboard", color: "blue",
    data: ["Get dashboard info","Get dashboard client org_details","Get wave chart","Get transaction analysis","Get transaction approved gateways","Get transaction decline gateways","Get transaction failed gateways","Get transaction errored gateways","Get transaction approved currency","Get transaction decline currency","Get transaction failed currency","Get transaction errored currency","Get client by organization"] },
  { id: "clientgateway", label: "Client Gateway", color: "green",
    data: ["Create client gateway","Delete client gateway","Update client gateway","Get client all gateways","Get client gateway details","Get charge options details"] },
  { id: "customer", label: "Customer", color: "purple",
    data: ["Get all customer","Get customer details","Create customer","Update customer","Create payment method","Delete payment method"] },
  { id: "crypto", label: "Crypto", color: "amber",
    data: ["View Crypto Payout List","View Crypto Payin","View single crypto payout list"] },
  { id: "fiat", label: "Fiat", color: "blue",
    data: ["View Fiat Payout List","View single fiat payout list"] },
];

const COLOR_MAP: Record<string, { header: string; dot: string; text: string }> = {
  blue:   { header: "linear-gradient(135deg,#eff6ff,#dbeafe)", dot: "#bfdbfe", text: "#2563eb" },
  green:  { header: "linear-gradient(135deg,#f0fdf4,#dcfce7)", dot: "#bbf7d0", text: "#16a34a" },
  amber:  { header: "linear-gradient(135deg,#fffbeb,#fef3c7)", dot: "#fde68a", text: "#d97706" },
  purple: { header: "linear-gradient(135deg,#faf5ff,#ede9fe)", dot: "#ddd6fe", text: "#7c3aed" },
  red:    { header: "linear-gradient(135deg,#fff1f2,#ffe4e6)", dot: "#fecdd3", text: "#e11d48" },
};

const LABEL_OVERRIDES: Record<string, string> = {
  "Get dashboard client org_details": "Get dashboard client organization details",
  "View Crypto Payout List": "View Crypto Batch Payout List",
  "View Fiat Payout List": "View Fiat Batch Payout List",
};

function CrerateSettlementReport(props: {
  allOrgDetails: any;
  fetchAllsettlement: () => void;
  info?: any;
  isInfo?: boolean;
  roleData?: any;
}) {
  const { allOrgDetails, fetchAllsettlement, info, isInfo, roleData } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [apiAccessFormData, setApiAccessFormData] = useState<any>({});
  const [initialValues, setInitialFormValues] = useState<any>({});
  const [userVerificationData, setUserVerificationData] = useState<any>({});
  const [isOpen2FAPopup, setIsOpen2FAPopup] = useState<boolean>(false);
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [isCloseModal2fa, setIsCloseModal2fa] = useState<boolean>(false);
  const [authCode, setAuthCode] = useState(["", "", "", "", "", ""]);
  const [apiTokenError, setApiTokenError] = useState("");
  const [expiryDateError, setExpiryDateError] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [TwoFaLoading, setTwoFaLoading] = useState(false);
  const inputRefs = useRef<Array<HTMLInputElement | null>>(new Array(6).fill(null));
  const [viewMode , setViewMode] = useState<boolean>(isInfo);
  /* Per-section selection state */
  const [sel, setSel] = useState<Record<string, string[]>>({});
  const getSel = (id: string) => sel[id] || [];
  const setSec = (id: string, val: string[]) => setSel((p) => ({ ...p, [id]: val }));

  const handleClose = () => {
    setApiAccessFormData({});
    setSel({});
    setApiTokenError("");
    setViewMode(isInfo);
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const handleCheckboxChange = (event: any) => {
    const { value, id } = event.target;
    const section = PERM_SECTIONS.find((s) => s.id === id);
    if (!section) return;
    const current = getSel(id);
    if (value === "all") setSec(id, current.length === section.data.length ? [] : [...section.data]);
    else if (value === "-1") setSec(id, []);
    else setSec(id, current.includes(value) ? current.filter((d) => d !== value) : [...current, value]);
  };

  const handleValueChange = (e: any) => {
    const { id, value } = e.target;
    if (id === "api_token" && !value) setApiTokenError("The field is required");
    else if (id === "api_token") setApiTokenError("");
    setApiAccessFormData((p: any) => ({ ...p, [id]: value }));
  };

  const getTokenDetailsById = () => {
    getAPIAccessTokenById(info?.row?.original?.id)
      .then((res) => {
        onOpen();
        const resData = res[0];
        setApiAccessFormData({
          api_token: resData?.name,
          daily_api_limit: resData?.api_hit_limit,
          isExpiry_ckbox: resData?.expiry_date !== null,
          expiry_date: resData?.expiry_date ? new Date(resData.expiry_date) : null,
          status: resData?.status,
        });
        const perms = resData?.endpoints_url_permissions;
        if (perms) {
          const newSel: Record<string, string[]> = {};
          PERM_SECTIONS.forEach((section) => {
            const permKey = section.id === "clientgateway" ? "client_gateway_operations"
              : section.id === "customer" ? "customer_operations"
              : section.id === "crypto" ? "crypto_operations"
              : section.id === "fiat" ? "fiat_operations"
              : `${section.id}_operetaion_permission`.replace("transaction_operetaion_permission", "transaction_operation_permission").replace("token_operetaion_permission", "token_operation_permission").replace("role_operetaion_permission", "role_operation_permission").replace("dashboard_operetaion_permission", "dashboard_operation_permission");
            const permData = perms?.[permKey] || {};
            newSel[section.id] = section.data.filter((item) => permData[item.toLowerCase().replace(/ /g, "_")]);
          });
          setSel(newSel);
        }
      })
      .catch(() => setApiAccessFormData({}));
  };

  const validateDataForm = () => {
    if (!apiAccessFormData.api_token?.trim()) { setApiTokenError("The field is required"); return false; }

    if (apiAccessFormData.isExpiry_ckbox && !apiAccessFormData.expiry_date) {
      setExpiryDateError("The field is required");
      return false;
    }
    return true;
  };

  const buildPayload = () => {
    const g = (id: string, item: string) => getSel(id).includes(item);
    return {
      name: apiAccessFormData?.api_token,
      expiry_date: apiAccessFormData?.isExpiry_ckbox ? moment(apiAccessFormData?.expiry_date).format("YYYY-MM-DD, HH:mm:ss") : null,
      api_hit_limit: apiAccessFormData?.daily_api_limit,
      status: apiAccessFormData?.status || null,
      endpoints_url_permissions: {
        client_operetaion_permission: { create_client: g("client","Create client"), update_client_details: g("client","Update client details"), get_all_clients: g("client","Get all clients"), get_client_details: g("client","Get client details"), delete_client: g("client","Delete client") },
        user_operetaion_permission: { register_user: g("user","Register user"), verify_otp: g("user","Verify otp"), get_user_profile: g("user","Get user profile"), get_all_users_details: g("user","Get all users details"), create_2fa_auth_details: g("user","Create 2fa auth details"), update_user_profile: g("user","Update user profile"), update_user_password: g("user","Update user password"), update_user_details: g("user","Update user details"), manage_2fa_authentication: g("user","Manage 2fa authentication"), delete_user_profile: g("user","Delete user profile"), delete_user_details: g("user","Delete user details") },
        organization_operetaion_permission: { create_organization: g("organization","Create organization"), get_all_organization: g("organization","Get all organization"), get_organization_details: g("organization","Get organization details"), update_organization_details: g("organization","Update organization details"), delete_organization: g("organization","Delete organization") },
        transaction_operation_permission: { get_all_payments_details: g("transaction","Get all payments details"), get_payment_history: g("transaction","Get payment history"), refund_payment: g("transaction","Refund payment"), retry_payment: g("transaction","Retry payment"), view_report: g("transaction","View Report"), change_payment_status: g("transaction","Change payment status") },
        gateways_operetaion_permission: { get_all_gateways: g("gateway","Get all gateways"), get_gateway_details: g("gateway","Get gateway details") },
        subscriptions_operetaion_permission: { get_all_subscription: g("subscription","Get all subscription"), get_subscription_details: g("subscription","Get subscription details"), cancel_subscription: g("subscription","Cancel subscription") },
        token_operation_permission: { get_all_token: g("token","Get all token"), get_token: g("token","Get token") },
        role_operation_permission: { create_role: g("role","Create role"), get_role_by_id: g("role","Get role by id"), get_all_roles: g("role","Get all roles"), update_role: g("role","Update role"), delete_role: g("role","Delete role") },
        dashboard_operation_permission: { get_dashboard_info: g("dashboard","Get dashboard info"), get_dashboard_client_org_details: g("dashboard","Get dashboard client org_details"), get_wave_chart: g("dashboard","Get wave chart"), get_transaction_analysis: g("dashboard","Get transaction analysis"), get_transaction_approved_gateways: g("dashboard","Get transaction approved gateways"), get_transaction_decline_gateways: g("dashboard","Get transaction decline gateways"),get_transaction_failed_gateways: g("dashboard","Get transaction failed gateways"),get_transaction_errored_gateways: g("dashboard","Get transaction errored gateways"), get_transaction_approved_currency: g("dashboard","Get transaction approved currency"), get_transaction_decline_currency: g("dashboard","Get transaction decline currency"),get_transaction_failed_currency: g("dashboard","Get transaction failed currency"),get_transaction_errored_currency: g("dashboard","Get transaction errored currency"), get_client_by_organization: g("dashboard","Get client by organization") },
        client_gateway_operations: { create_client_gateway: g("clientgateway","Create client gateway"), delete_client_gateway: g("clientgateway","Delete client gateway"), update_client_gateway: g("clientgateway","Update client gateway"), get_client_all_gateways: g("clientgateway","Get client all gateways"), get_client_gateway_details: g("clientgateway","Get client gateway details"), get_charge_options_details: g("clientgateway","Get charge options details") },
        customer_operations: { get_all_customer: g("customer","Get all customer"), get_customer_details: g("customer","Get customer details"), create_customer: g("customer","Create customer"), update_customer: g("customer","Update customer"), create_payment_method: g("customer","Create payment method"), delete_payment_method: g("customer","Delete payment method") },
        crypto_operations: { view_crypto_payout_list: g("crypto","View Crypto Payout List"), view_crypto_payin: g("crypto","View Crypto Payin"), view_single_crypto_payout_list: g("crypto","View single crypto payout list") },
        fiat_operations: { view_fiat_payout_list: g("fiat","View Fiat Payout List"), view_single_fiat_payout_list: g("fiat","View single fiat payout list") },
      },
    };
  };

  const handleSubmit = () => {
    if (!validateDataForm()) return;
    setIsLoading(true);
    const data = buildPayload();
    if (info?.row?.original?.id) {
      updateAPITokenRecord(data, info.row.original.id)
        .then(() => { setIsLoading(false); toast.success("API Token updated successfully"); fetchAllsettlement(); handleClose(); })
        .catch(() => { setIsLoading(false); toast.error("Something went wrong!"); });
    } else {
      createAPItoken(data)
        .then(() => { setIsLoading(false); toast.success("API Token created successfully"); fetchAllsettlement(); handleClose(); })
        .catch(() => { setIsLoading(false); toast.error("Something went wrong!"); });
    }
  };

  const fetchProfileData = () => {
    getProfileSecond()
      .then((res) => { setUserVerificationData({ is_auth_2fa_activate: res[0]?.auth_2fa }); setIsOpen2FAPopup(true); })
      .catch(() => {});
  };

  const onClose2FAPopup = () => {
    setIsOpen2FAPopup(false);
    setAuthCode(["", "", "", "", "", ""]);
    setUserVerificationData({});
    setIsCloseModal2fa(true);
    setTimeout(() => setIsCloseModal2fa(false), 300);
  };

  const handleVerify2FA = () => {
    setTwoFaLoading(true);
    const passcode = authCode.join("");
    if (!userVerificationData?.password) { setTwoFaLoading(false); toast.error("Please enter password"); return; }
    if (userVerificationData.password.length < 8) { setTwoFaLoading(false); toast.error("Password must be at least 8 characters"); return; }
    if (passcode.length < 6) { setTwoFaLoading(false); toast.error("Please enter valid 2FA code"); return; }
    verifyBackOfficeAPI({ password: userVerificationData.password, otp: passcode, backoffice_access_token_id: userVerificationData?.backoffice_access_token_id })
      .then((res) => { setTwoFaLoading(false); toast.success(res?.message); if (res?.is_verified) onOpen(); onClose2FAPopup(); })
      .catch((error) => { setTwoFaLoading(false); toast.error(error?.response?.data?.message ?? "Something went wrong!"); });
  };

  const handleOTPChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newCode = [...authCode]; newCode[index] = value; setAuthCode(newCode);
      if (value && index < 5) inputRefs.current[index + 1]?.focus();
    }
  };
  const handleOTPKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !authCode[index] && index > 0) inputRefs.current[index - 1]?.focus();
  };
  const handleOTPPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const d = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(d)) { setAuthCode(d.split("")); inputRefs.current[5]?.focus(); }
  };

  /* ── Trigger ── */
  const TriggerEl = () => {
    if (isInfo) {
      if (!roleData?.[0]?.api?.value?.view_api) return null;
      return (
        <Popover trigger="hover" placement="bottom">
          <PopoverTrigger>
            <div onClick={() => { getTokenDetailsById(); setViewMode(true);}}>
              <div className="api-action-icon api-action-icon--blue"><MdInfo size={16}/></div>
            </div>
          </PopoverTrigger>
          <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="180px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="12px" py="9px">View Token</PopoverHeader>
            <PopoverArrow bg="#eff6ff"/>
          </PopoverContent>
        </Popover>
      );
    }
    if (info?.row?.original?.id) {
      if (!roleData?.[0]?.api?.value?.edit_api) return null;
      return (
        <Popover trigger="hover" placement="bottom">
          <PopoverTrigger>
            <div onClick={() =>{ getTokenDetailsById(); setViewMode(false); }}>
              <div className="api-action-icon api-action-icon--amber"><MdEdit size={16}/></div>
            </div>
          </PopoverTrigger>
          <PopoverContent border="1px solid #fde68a" borderRadius="12px" bg="#fffbeb" maxW="180px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#fef3c7" fontSize="12px" fontWeight="700" color="#92400e" borderBottom="1px solid #fde68a" px="12px" py="9px">Edit Token</PopoverHeader>
            <PopoverArrow bg="#fffbeb"/>
          </PopoverContent>
        </Popover>
      );
    }
    return (
      <button className="api-add-btn" onClick={fetchProfileData}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
        </svg>
        Create API Token
      </button>
    );
  };

  return (
    <>
      <TriggerEl/>

      {/* ── Main Create/Edit Panel ── */}
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)"/>
        <div className={`api-panel${isOpen && !isCloseModal ? " api-panel--open" : " api-panel--close"}`}>
          <div className="api-top-glow"/>
          <div className="api-header">
            <div className="api-header-brand">
              <div className="api-header-logo">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div>
                <h2 className="api-header-title">{info?.row?.original?.id ? (viewMode ? "View API Token" : "Edit API Token") : "Create API Token"}</h2>
                <p className="api-header-sub">Configure token name, limits, expiry & permissions</p>
              </div>
            </div>
            <div className="api-header-right">
              {viewMode && roleData?.[0]?.api?.value?.edit_api && (
                <button className="api-edit-btn" onClick={() => { getTokenDetailsById(); setViewMode(false); }}>
                  <MdEdit size={13}/> Switch to Edit
                </button>
              )}
              <button className="api-close-btn" onClick={handleClose} aria-label="Close"><MdHighlightOff size={22}/></button>
            </div>
          </div>

          <div className="api-body">
            {/* Token name */}
            <div className="api-section">
              <div className="api-section-icon api-section-icon--amber">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div className="api-section-content">
                <h3 className="api-section-title">Token Settings</h3>
                <p className="api-section-desc">Name, limit, expiry and status</p>
              </div>
            </div>
            <div className="api-section">
              <div className="api-section-content-form">
                <div className="api-field-wrap">
                  <label className="api-label">Token Name <span className="api-req">*</span></label>
                  <input
                    type="text" id="api_token"
                    className={`api-input${apiTokenError ? " api-input--err" : ""}`}
                    placeholder="e.g. My Production Token"
                    disabled={viewMode}
                    value={apiAccessFormData?.api_token ?? ""}
                    onChange={handleValueChange}
                  />
                  {apiTokenError && <p className="api-err">{apiTokenError}</p>}
                </div>

                <div className="api-field-wrap">
                  <label className="api-label">API Hit Limit <span className="api-opt">(optional)</span></label>
                  <input
                    type="number" id="daily_api_limit"
                    className="api-input"
                    placeholder="e.g. 1000"
                    disabled={viewMode}
                    value={apiAccessFormData?.daily_api_limit ?? ""}
                    onInput={(e: any) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }}
                    onChange={handleValueChange}
                  />
                </div>

                {(viewMode || info?.row?.original?.id) && (
                  <div className="api-field-wrap">
                    <label className="api-label">Status</label>
                    <select
                      id="status"
                      className="api-input"
                      value={apiAccessFormData?.status}
                      onChange={handleValueChange}
                      disabled={viewMode || !roleData?.[0]?.api?.value?.block_api}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="BLOCK">BLOCK</option>
                    </select>
                  </div>
                )}

                <label className="api-checkbox-row">
                  <Checkbox
                    id="isExpiry_ckbox"
                    value={!apiAccessFormData?.isExpiry_ckbox}
                    checked={apiAccessFormData?.isExpiry_ckbox}
                    onChange={(e: any) => {
                      const val = e.target.value;
                      setApiAccessFormData((p: any) => ({ ...p, isExpiry_ckbox: val === "true" ? true : val === "false" ? false : null }));
                    }}
                    disabled={viewMode}
                    color={viewMode ? "gray" : ""}
                  />
                  <span className="api-checkbox-label">Set Expiry Date</span>
                </label>

                {apiAccessFormData?.isExpiry_ckbox && (
                  <div className="api-field-wrap">
                    <input
                      className="api-input"
                      type="datetime-local"
                      min={moment().format("YYYY-MM-DDTHH:mm")}
                      onKeyDown={(e) => e.preventDefault()}
                      disabled={viewMode}
                      value={apiAccessFormData?.expiry_date ? moment.utc(apiAccessFormData.expiry_date).format("YYYY-MM-DDTHH:mm") : ""}
                      onChange={(e) => {
                        const v = e.target.value ? moment.utc(e.target.value).format("YYYY-MM-DDTHH:mm") : null;
                        setApiAccessFormData((p: any) => ({ ...p, expiry_date: v }));
                        if (v) {
                          setExpiryDateError("");
                        }
                      }}
                    />
                    {expiryDateError && <p className="api-err">{expiryDateError}</p>}
                  </div>
                )}
              </div>
            </div>

            <div className="api-divider">
              <span className="api-divider-label">API Permissions</span>
              <div className="api-divider-line"/>
            </div>

            {/* Permission grid */}
            <div className="api-perm-grid">
              {PERM_SECTIONS.map((section) => {
                const current = getSel(section.id);
                const isAll = section.data.length > 0 && current.length === section.data.length;
                const col = COLOR_MAP[section.color];
                return (
                  <div key={section.id} className="api-perm-card">
                    <div className="api-perm-header" style={{ background: col.header, borderColor: col.dot }}>
                      <Checkbox
                        id={section.id}
                        value={isAll ? "-1" : "all"}
                        checked={isAll}
                        onChange={handleCheckboxChange}
                        disabled={viewMode}
                        color={viewMode ? "gray" : ""}
                      />
                      <span className="api-perm-title" style={{ color: col.text }}>{section.label}</span>
                      {current.length > 0 && (
                        <span className="api-perm-count" style={{ background: col.dot, color: col.text }}>{current.length}/{section.data.length}</span>
                      )}
                    </div>
                    <div className="api-perm-body">
                      {section.data.map((item) => (
                        <label key={item} className="api-perm-row">
                          <Checkbox
                            id={section.id}
                            value={item}
                            checked={current.includes(item)}
                            onChange={handleCheckboxChange}
                            disabled={viewMode}
                            color={viewMode ? "gray" : ""}
                          />
                          <span className="api-perm-label">{LABEL_OVERRIDES[item] ?? item}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="api-footer">
            <span className="api-footer-hint">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              Tokens are encrypted at rest
            </span>
            <div className="api-footer-btns">
              <button className="api-btn-cancel" onClick={handleClose}>Cancel</button>
              {!viewMode && (
                <button className="api-btn-submit" onClick={handleSubmit} disabled={isLoading}>
                  {isLoading ? <span className="api-spinner"/> : (
                    <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    {info?.row?.original?.id ? "Update Token" : "Create Token"}</>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      {/* ── 2FA Popup ── */}
      <Modal isOpen={isOpen2FAPopup} onClose={onClose2FAPopup}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)"/>
        <div className={`api-2fa-panel${isOpen2FAPopup && !isCloseModal2fa ? " api-panel--open" : " api-panel--close"}`}>
          <div className="api-top-glow-2fa"/>
          <div className="api-header" style={{ background: "linear-gradient(135deg,#1e3a8a,#1d4ed8)" }}>
            <div className="api-header-brand">
              <div className="api-header-logo">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div>
                <h2 className="api-header-title">2FA Verification</h2>
                <p className="api-header-sub">Verify identity to create this API token</p>
              </div>
            </div>
            <button className="api-close-btn" onClick={onClose2FAPopup} aria-label="Close"><MdHighlightOff size={22}/></button>
          </div>

          <div className="api-body">
            {!userVerificationData?.is_auth_2fa_activate ? (
              <div className="api-2fa-disabled">
                <div className="api-2fa-disabled-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                </div>
                <p className="api-2fa-disabled-title">2FA Not Activated</p>
                <p className="api-2fa-disabled-desc">
                  Please visit <Link to="/admin/profile" className="api-link">profile settings</Link> and activate 2FA to create API tokens.
                </p>
              </div>
            ) : (
              <>
                <p className="api-2fa-hint">Enter your password and 6-digit 2FA code to proceed.</p>
                <div className="api-field-wrap">
                  <label className="api-label">Password <span className="api-req">*</span></label>
                  <InputField
                    variant="auth" extra="w-full" label="" placeholder="Enter your password"
                    id="password" type={userVerificationData?.isShow ? "text" : "password"}
                    value={userVerificationData?.password}
                    onChange={(e: any) => setUserVerificationData((p: any) => ({ ...p, [e.target.id]: e.target.value }))}
                    passwordShow={userVerificationData?.isShow}
                    setPasswordShow={() => setUserVerificationData((p: any) => ({ ...p, isShow: !p?.isShow }))}
                  />
                </div>
                <div className="api-field-wrap">
                  <label className="api-label">2FA Code <span className="api-req">*</span></label>
                  <div className="si-otp-group">
                    {authCode.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOTPChange(index, e)}
                        onKeyDown={(e) => handleOTPKeyDown(index, e)}
                        onPaste={index === 0 ? handleOTPPaste : undefined}
                        className={`si-otp-inp${digit ? " si-otp-inp--filled" : ""}`}
                        aria-label={`Digit ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="api-footer">
            <span/>
            <div className="api-footer-btns">
              <button className="api-btn-cancel" onClick={onClose2FAPopup}>Cancel</button>
              {userVerificationData?.is_auth_2fa_activate && (
                <button className="api-btn-submit" onClick={handleVerify2FA} disabled={TwoFaLoading}>
                  {TwoFaLoading ? <span className="api-spinner"/> : (
                    <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Verify &amp; Proceed</>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .api-add-btn {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg,#d97706,#f59e0b);
          cursor: pointer; box-shadow: 0 3px 12px rgba(217,119,6,.28);
          transition: transform .15s, box-shadow .18s;
        }
        .api-add-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(217,119,6,.36); }

        .api-action-icon {
          width: 32px; height: 32px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .15s; border: 1.5px solid;
        }
        .api-action-icon--blue { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
        .api-action-icon--blue:hover { background: #dbeafe; }
        .api-action-icon--amber { background: #fffbeb; border-color: #fde68a; color: #d97706; }
        .api-action-icon--amber:hover { background: #fef3c7; }

        /* Panels */
        .api-panel, .api-2fa-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 860px;
          background: #fff; z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -12px 0 60px rgba(15,23,42,.18);
          transition: transform .35s cubic-bezier(0.16,1,0.3,1);
          overflow: hidden;
        }
        .api-2fa-panel { max-width: 560px; }
        .api-panel--open  { transform: translateX(0); }
        .api-panel--close { transform: translateX(100%); }

        .api-top-glow {
          height: 3px; flex-shrink: 0;
          background: linear-gradient(90deg,#92400e,#d97706,#f59e0b,#d97706,#92400e);
          background-size: 200% 100%;
          animation: apiGlow 3s linear infinite;
        }
        @keyframes apiGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .api-top-glow-2fa {
          height: 3px; flex-shrink: 0;
          background: linear-gradient(90deg,#1e3a8a,#2563eb,#7c3aed,#2563eb,#1e3a8a);
          background-size: 200% 100%;
          animation: achGlow 3s linear infinite;
        }
        @keyframes owzGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .api-header {
          padding: 15px 26px;
          background: linear-gradient(135deg,#92400e 0%,#b45309 60%,#d97706 100%);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .api-header-brand { display: flex; align-items: center; gap: 13px; }
        .api-header-logo {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(255,255,255,.15); border: 1.5px solid rgba(255,255,255,.25);
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .api-header-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 1; }
        .api-header-sub { font-size: 12px; color: rgba(255,255,255,.55); font-weight: 500; }
        .api-header-right { display: flex; align-items: center; gap: 10px; }
        .api-edit-btn {
          display: inline-flex; align-items: center; gap: 5px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 12px; font-weight: 700; color: #fff;
          background: rgba(255,255,255,.14); border: 1.5px solid rgba(255,255,255,.25);
          border-radius: 8px; padding: 7px 12px; cursor: pointer; transition: background .15s;
        }
        .api-edit-btn:hover { background: rgba(255,255,255,.24); }
        .api-close-btn {
          background: none; border: none; cursor: pointer;
          color: rgba(255,255,255,.65); display: flex; align-items: center; transition: color .15s;
        }
        .api-close-btn:hover { color: #fff; }

        .api-body { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 24px 28px; display: flex; flex-direction: column; gap: 20px; }
        .api-body::-webkit-scrollbar { width: 4px; }
        .api-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Settings section */
        .api-section { display: flex; gap: 16px; align-items: flex-start; }
        .api-section-icon {
          width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center; margin-top: 2px;
        }
        .api-section-icon--amber { background: linear-gradient(135deg,#fffbeb,#fef3c7); border: 1.5px solid #fde68a; color: #d97706; }
        .api-section-content { flex: 1; display: flex; flex-direction: column; }
        .api-section-content-form { flex: 1; display: flex; flex-direction: column; gap: 10px; }
        .api-section-title { font-size: 15px; font-weight: 800; color: #0f172a; letter-spacing: -.2px;}
        .api-section-desc { font-size: 12.5px; color: #64748b; font-weight: 500; margin-bottom: 4px; }

        .api-field-wrap { display: flex; flex-direction: column; gap: 5px; }
        .api-label { font-size: 12.5px; font-weight: 700; color: #374151; }
        .api-req { color: #dc2626; }
        .api-opt { font-size: 11px; font-weight: 500; color: #94a3b8; }
        .api-input {
          width: 100%; padding: 11px 14px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 11px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; color: #0f172a;
          outline: none; transition: border-color .18s; box-sizing: border-box;
        }
        .api-input:focus { border-color: #d97706; background: #fff; box-shadow: 0 0 0 3px rgba(217,119,6,.08); }
        .api-input--err { border-color: #ef4444 !important; background: #fff7f7 !important; }
        .api-input:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }
        .api-err { font-size: 12px; color: #dc2626; font-weight: 500; }
        .api-checkbox-row { display: flex; align-items: center; gap: 8px; cursor: pointer; }
        .api-checkbox-label { font-size: 13px; font-weight: 600; color: #374151; }

        /* Divider */
        .api-divider { display: flex; align-items: center; gap: 10px; }
        .api-divider-label { font-size: 10px; font-weight: 800; color: #b8c4d8; text-transform: uppercase; letter-spacing: 1px; white-space: nowrap; }
        .api-divider-line { flex: 1; height: 1px; background: linear-gradient(90deg,#e4e9f4,transparent); }

        /* Permission grid */
        .api-perm-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; }
        .api-perm-card { border-radius: 12px; overflow: hidden; border: 1.5px solid #e2e8f0; box-shadow: 0 1px 4px rgba(15,23,42,.04); transition: box-shadow .18s; }
        .api-perm-card:hover { box-shadow: 0 4px 12px rgba(15,23,42,.07); }
        .api-perm-header { display: flex; align-items: center; gap: 8px; padding: 9px 12px; border-bottom: 1.5px solid; }
        .api-perm-title { font-size: 12.5px; font-weight: 800; flex: 1; }
        .api-perm-count { font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 20px; }
        .api-perm-body { padding: 10px 12px; display: flex; flex-direction: column; gap: 7px; max-height: 200px; overflow-y: auto; background: #fff; }
        .api-perm-body::-webkit-scrollbar { width: 3px; }
        .api-perm-body::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 3px; }
        .api-perm-row { display: flex; align-items: flex-start; gap: 7px; cursor: pointer; }
        .api-perm-label { font-size: 12px; font-weight: 500; color: #374151; line-height: 1.4; padding-top: 1px; }

        /* 2FA */
        .api-2fa-disabled { display: flex; flex-direction: column; align-items: center; gap: 12px; text-align: center; padding: 24px 0; }
        .api-2fa-disabled-icon { width: 56px; height: 56px; border-radius: 14px; background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; color: #2563eb; }
        .api-2fa-disabled-title { font-size: 15px; font-weight: 700; color: #0f172a; }
        .api-2fa-disabled-desc { font-size: 13px; color: #64748b; font-weight: 500; line-height: 1.6; }
        .api-2fa-hint { font-size: 13px; color: #64748b; font-weight: 500; }
        .api-link { color: #2563eb; font-weight: 700; }
        .si-otp-group { display: flex; justify-content: flex-start; gap: 10px; }
        .si-otp-inp {
          width: 54px; height: 62px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 14px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 24px; font-weight: 700;
          color: #0f172a; text-align: center; outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none; caret-color: #2563eb;
        }
        .si-otp-inp:focus {
          border-color: #2563eb; background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .si-otp-inp--filled {
          border-color: #93c5fd; background: #eff6ff; color: #1d4ed8;
        }
        @media (max-width: 600px) {
          .si-otp-group { gap: 8px; }
          .si-otp-inp { width: 46px; height: 54px; font-size: 20px; border-radius: 12px; }
        }
        @media (max-width: 380px) {
          .si-otp-inp { width: 40px; height: 48px; font-size: 18px; border-radius: 10px; }
          .si-otp-group { gap: 6px; }
        }

        /* Footer */
        .api-footer {
          padding: 14px 26px; border-top: 1.5px solid #f1f5f9; background: #fafbfc;
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 10px; flex-shrink: 0;
        }
        .api-footer-hint { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .api-footer-btns { display: flex; align-items: center; gap: 8px; }
        .api-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; color: #64748b;
          padding: 9px 16px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all .15s;
        }
        .api-btn-cancel:hover { background: #f1f5f9; color: #374151; }
        .api-btn-submit {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg,#d97706,#f59e0b);
          cursor: pointer; box-shadow: 0 4px 14px rgba(217,119,6,.28);
          transition: transform .15s, box-shadow .18s; position: relative; overflow: hidden;
        }
        .api-btn-submit::after { content:''; position:absolute; inset:0; background:linear-gradient(135deg,rgba(255,255,255,.1),transparent 60%); }
        .api-btn-submit:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(217,119,6,.36); }
        .api-btn-submit:disabled { opacity: .5; cursor: not-allowed; transform: none; }
        .api-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.35); border-top-color: #fff; border-radius: 50%; animation: apiSpin .65s linear infinite; }
        @keyframes apiSpin { to{transform:rotate(360deg)} }

        @media (max-width: 640px) {
          .api-panel, .api-2fa-panel { max-width: 100%; }
          .api-header { padding: 16px 18px; }
          .api-body { padding: 18px; }
          .api-footer { padding: 12px 18px; }
          .api-perm-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </>
  );
}

export default CrerateSettlementReport;